import { SET_LOADING_PLACES } from "../Actions/Types";

export interface IMobilyticsPlacesState {
  placesLoading: boolean;
}

export const defaultState: IMobilyticsPlacesState = {
    placesLoading: false,
};

export const mobilyticsPlaces = (
    state: IMobilyticsPlacesState = { ...defaultState },
    action
): IMobilyticsPlacesState => {
    switch (action.type) {
        case SET_LOADING_PLACES:
            return {
                ...state,
                placesLoading: action.data as boolean,
            };

        default:
            return state;
    }
};
